<template>
  <div class="chronopost">
    <h2 class="h4">Forfait Chronopost</h2>
    <div class="ibox">
      <div class="ibox-content">
        <b-form @submit.prevent="save">
          <b-form-row>
            <b-col md="3" sm="6">
              <b-form-group label="Forfait aller/retour" label-for="chronopost-flat">
                <b-input-group append="€">
                  <b-form-input
                    id="chronopost-flat"
                    v-model.number="form.transport_chronopost_flat"
                    type="number"
                    step="0.01"
                    min="0"
                    :disabled="!canEdit || isBusy"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3" sm="6">
              <b-form-group label="Seuil de poids" label-for="chronopost-max-weight">
                <b-input-group append="kg">
                  <b-form-input
                    id="chronopost-max-weight"
                    v-model.number="form.transport_chronopost_max_weight"
                    type="number"
                    step="0.1"
                    min="0.1"
                    :disabled="!canEdit || isBusy"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-form-row>

          <!-- Récapitulatif en clair : la règle appliquée se lit d'un coup, sans avoir
               à recomposer mentalement les deux champs. -->
          <p class="chronopost__summary">
            <i class="far fa-info-square"></i>
            <span v-if="hasValues">
              Une commande intégralement expédiable en Chronopost (poids total sous
              <strong>{{ form.transport_chronopost_max_weight }} kg</strong>) est facturée
              <strong>{{ form.transport_chronopost_flat }} €</strong> pour l'aller-retour,
              une seule fois à la livraison. Au-delà, la grille messagerie ci-dessous
              s'applique.
            </span>
            <span v-else class="chronopost__summary-loading">Chargement du forfait&hellip;</span>
          </p>

          <b-button v-if="canEdit" type="submit" variant="primary" :disabled="isBusy">
            <i v-if="isBusy" class="fa fa-spinner fa-spin"></i>
            Enregistrer
          </b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axiosConnection";
import toastr from "@/toastr";

export default {
  name: "ChronopostSetting",
  data() {
    return {
      form: {
        transport_chronopost_flat: null,
        transport_chronopost_max_weight: null,
      },
      isBusy: false,
    };
  },
  computed: {
    canEdit() {
      return this.$root.isAuthorized("transport-rate_edit");
    },
    hasValues() {
      return (
        this.form.transport_chronopost_flat !== null &&
        this.form.transport_chronopost_max_weight !== null
      );
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.isBusy = true;
      axios
        .get("transportrate/chronopost")
        .then((response) => {
          this.form = {
            transport_chronopost_flat: response.data.transport_chronopost_flat,
            transport_chronopost_max_weight:
              response.data.transport_chronopost_max_weight,
          };
        })
        .catch(() => {
          toastr.error("Le chargement du forfait Chronopost a échoué");
        })
        .then(() => {
          this.isBusy = false;
        });
    },
    save() {
      this.isBusy = true;
      axios
        .patch("transportrate/chronopost", {
          transport_chronopost_flat: this.form.transport_chronopost_flat,
          transport_chronopost_max_weight: this.form.transport_chronopost_max_weight,
        })
        .then(() => {
          toastr.success("Forfait Chronopost enregistré");
        })
        .catch(() => {
          toastr.error("L'enregistrement du forfait Chronopost a échoué");
        })
        .then(() => {
          this.isBusy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.chronopost {
  // La règle en clair, mise en évidence sans crier : elle se lit avant les champs
  // pour qui vient juste vérifier le forfait en vigueur.
  &__summary {
    margin-bottom: 20px;
    padding: 10px 14px;
    border-left: 3px solid #1ab394;
    background-color: rgba(26, 179, 148, 0.06);
    border-radius: 0 3px 3px 0;
    font-size: 13px;
    line-height: 1.5;
    color: #5e6366;

    i {
      margin-right: 6px;
      color: #1ab394;
    }

    strong {
      color: #333;
    }
  }

  &__summary-loading {
    color: #999;
    font-style: italic;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TransportRate/ChronopostSetting.vue